(function () {
  "use strict";

  var e = {};
  (function () {
    var n = e;
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), n.EthereumNetworks = void 0;
    n.EthereumNetworks = {
      ethereum_mainnet: {
        name: "ethereum_mainnet",
        coinType: "60",
        networkId: 1,
        chainId: 1,
        isTestnet: !1
      },
      classic_mainnet: {
        name: "classic_mainnet",
        coinType: "61",
        networkId: 1,
        chainId: 61,
        isTestnet: !1
      },
      ropsten: {
        name: "ropsten",
        coinType: "60",
        networkId: 3,
        chainId: 3,
        isTestnet: !0
      },
      rinkeby: {
        name: "rinkeby",
        coinType: "60",
        networkId: 4,
        chainId: 4,
        isTestnet: !0
      },
      kovan: {
        name: "kovan",
        coinType: "60",
        networkId: 42,
        chainId: 42,
        isTestnet: !0
      },
      goerli: {
        name: "goerli",
        coinType: "60",
        networkId: 5,
        chainId: 5,
        isTestnet: !0
      },
      rsk_mainnet: {
        name: "rsk_mainnet",
        coinType: "60",
        networkId: 30,
        chainId: 30,
        isTestnet: !1
      },
      rsk_testnet: {
        name: "rsk_testnet",
        coinType: "60",
        networkId: 31,
        chainId: 31,
        isTestnet: !0
      },
      rsk_regtest: {
        name: "rsk_regtest",
        coinType: "37310",
        networkId: 33,
        chainId: 33,
        isTestnet: !0
      },
      bsc_mainnet: {
        name: "bsc_mainnet",
        coinType: "60",
        networkId: 56,
        chainId: 56,
        isTestnet: !1
      },
      bsc_testnet: {
        name: "bsc_testnet",
        coinType: "60",
        networkId: 97,
        chainId: 97,
        isTestnet: !0
      },
      polygon_mainnet: {
        name: "polygon_mainnet",
        coinType: "60",
        networkId: 137,
        chainId: 137,
        isTestnet: !1
      },
      polygon_testnet: {
        name: "polygon_testnet",
        coinType: "60",
        networkId: 80001,
        chainId: 80001,
        isTestnet: !0
      },
      arbitrum_testnet: {
        name: "arbitrum_testnet",
        coinType: "60",
        networkId: 421611,
        chainId: 421611,
        isTestnet: !0
      },
      arbitrum_mainnet: {
        name: "arbitrum_mainnet",
        coinType: "60",
        networkId: 42161,
        chainId: 42161,
        isTestnet: !1
      },
      fuse_testnet: {
        name: "fuse_testnet",
        coinType: "60",
        networkId: 123,
        chainId: 123,
        isTestnet: !0
      },
      fuse_mainnet: {
        name: "fuse_mainnet",
        coinType: "60",
        networkId: 122,
        chainId: 122,
        isTestnet: !1
      },
      avax_testnet: {
        name: "avalanche_testnet",
        coinType: "60",
        networkId: 43113,
        chainId: 43113,
        isTestnet: !0
      },
      avax_mainnet: {
        name: "avalanche_mainnet",
        coinType: "60",
        networkId: 43114,
        chainId: 43114,
        isTestnet: !1
      },
      local: {
        name: "local",
        coinType: "60",
        networkId: 1337,
        chainId: 1337,
        isTestnet: !0
      }
    };
  })(), module.exports = e;
})();